import React from 'react';
import { Markdown } from '@/components/common/Markdown';

interface AccountSummaryCardProps {
  summaryMarkdown?: string | null;
  enrichmentStatus?: 'pending' | 'enriched' | 'failed';
}

const AccountSummaryCard: React.FC<AccountSummaryCardProps> = ({
  summaryMarkdown,
  enrichmentStatus,
}) => {
  if (!summaryMarkdown) {
    const isPending = enrichmentStatus === 'pending';
    return (
      <div className="rounded-xl border border-border bg-card p-5">
        <div className="text-sm font-medium text-foreground mb-2">Account summary</div>
        <p className="text-sm text-muted-foreground">
          {isPending
            ? 'Generating analytics summary — this updates automatically after each new session.'
            : 'No summary yet. The summary regenerates automatically after each new session for this account.'}
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-border bg-card p-5">
      <div className="text-sm font-medium text-foreground mb-3">Account summary</div>
      <Markdown content={summaryMarkdown} className="text-sm" />
    </div>
  );
};

export default AccountSummaryCard;
